export default __webpack_public_path__ + "static/media/activity-repeated-alerts-icon.0cc3cad0.svg";